import module from "../module";

module.component("workflowWindowLayout", {
  transclude: true,
  template: "<div ng-transclude></div>"
});
